import { Select, SelectProps, Spin } from 'antd';
import { uniqueId } from 'lodash';
import React from 'react';

import Tabs from '@src/emp-3.0/components/common/Tabs';
import { ITabsProps } from '@src/emp-3.0/components/common/Tabs/typed';

import { NamedSelectWithExtrasWrapper } from './styled';

interface INamedSelectWithExtra {
  extraNodes?: React.ReactNode[] | null;
  selectProps?: SelectProps;
}

interface INameSelectWithTabs extends INamedSelectWithExtra, Omit<ITabsProps, 'onClick'> {
  onTabsItemClick?: ITabsProps['onClick'];
  dropdownRenderProps?: any;
}

const NamedSelectWithExtras: React.FC<INamedSelectWithExtra> = ({
  extraNodes,
  selectProps = {},
}) => {
  return (
    <NamedSelectWithExtrasWrapper>
      <Select
        placeholder="Type or select..."
        options={selectProps?.options}
        getPopupContainer={() => document.body}
        {...selectProps}
        style={{ minWidth: 100, ...selectProps.style }}
        dropdownStyle={{
          minWidth: '275px',
          borderRadius: '4px 4px 0 0',
          padding: 0,
          ...selectProps.dropdownStyle,
        }}
      />
      {extraNodes && (
        <div style={{ display: 'inline-flex', gap: '8px', alignItems: 'center', paddingLeft: 16 }}>
          {extraNodes?.map((node) => {
            return <React.Fragment key={uniqueId('select_extra_key_')}>{node}</React.Fragment>;
          })}
        </div>
      )}
    </NamedSelectWithExtrasWrapper>
  );
};

const NameSelectWithTabs: React.FC<INameSelectWithTabs> = ({
  activeTabKey,
  items,
  onTabsItemClick,
  selectProps,
  extraNodes,
  dropdownRenderProps = {},
}) => {
  return (
    <NamedSelectWithExtras
      extraNodes={extraNodes}
      selectProps={{
        dropdownRender: (menu) => {
          return (
            <div {...dropdownRenderProps}>
              {items && (
                <Tabs items={items} activeTabKey={activeTabKey} onClick={onTabsItemClick} />
              )}
              <Spin spinning={!!selectProps?.loading}>{menu}</Spin>
            </div>
          );
        },
        ...selectProps,
      }}
    />
  );
};

export type { INamedSelectWithExtra, INameSelectWithTabs };
export { NamedSelectWithExtras, NameSelectWithTabs };
